import styled from 'styled-components';

export const RiskCategoriesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.pxToRem(10)};
`;
